<template>
  <TheModuloContainer v-bind:modulo-system-name="moduloSystemName" />
</template>

<script>
import TheModuloContainer from "../components/TheModuloContainer.vue";

export default {
  name: "Modulo",
  components: {
    TheModuloContainer
  },
  inheritAttrs: false,
  props: {
    moduloSystemName: {
      type: String,
      required: true
    }
  }
};
</script>
